/* ============================================
   BRAND PAGE — Animations
   ============================================ */



/* ---------- HERO — animazione post preloader ---------- */
(function () {
  var hero    = document.querySelector('.hero-brand');
  var title   = document.querySelector('.hero-brand__title');
  var cols    = document.querySelectorAll('.hero-brand__col');
  var product = document.querySelector('.hero-brand__product');
  var nav     = document.querySelector('.dett-nav');
  var bottom  = document.querySelector('.dett-hero__bottom');
  if (!hero) return;

  function runIntro() {
    var tl = gsap.timeline({ defaults: { ease: 'power3.out' } });

    if (window.innerWidth > 1024) {
      if (nav)    tl.from(nav,    { yPercent: -100, opacity: 0, duration: 0.8 }, 0);
      if (bottom) tl.from(bottom, { yPercent: 100,  opacity: 0, duration: 0.8 }, 0);
    }

    if (title) {
      gsap.set(title, { y: 30 });
      tl.to(title, { opacity: 1, y: 0, duration: 1.2 }, 0.15);
    }

    if (cols.length) {
      gsap.set(cols, { y: 20 });
      tl.to(cols, { opacity: 1, y: 0, duration: 1, stagger: 0.15 }, 0.5);
    }

  }

  window.addEventListener('preloader-done', runIntro, { once: true });
})();


/* ---------- HERO — scroll dissolve ---------- */
(function () {
  var hero    = document.querySelector('.hero-brand');
  var video   = hero ? hero.querySelector('.hero-brand__video') : null;
  var content = hero ? hero.querySelector('.hero-brand__content') : null;
  var product = hero ? hero.querySelector('.hero-brand__product') : null;
  if (!hero) return;

  var dissolveTl = gsap.timeline({
    scrollTrigger: {
      trigger: hero,
      start: 'top top',
      end: 'bottom top',
      scrub: true,
    },
  });

  if (video) {
    dissolveTl.fromTo(video,
      { filter: 'contrast(1.1) brightness(0.85) saturate(0.8) blur(6px)' },
      { filter: 'contrast(1.1) brightness(0.6) saturate(0.8) blur(18px)', ease: 'none' }, 0
    );
  }

  dissolveTl.to('.hero-brand__overlay', { opacity: 1.8, ease: 'none' }, 0);

  if (content) {
    dissolveTl.to(content, { yPercent: -20, opacity: 0, ease: 'none' }, 0);
  }

  if (product) {
    dissolveTl.to(product, { opacity: 0, ease: 'none' }, 0.3);
  }
})();


/* ---------- HERO — product image parallax ---------- */
(function () {
  var hero    = document.querySelector('.hero-brand');
  var product = hero ? hero.querySelector('.hero-brand__product') : null;
  if (!product) return;

  gsap.to(product, {
    yPercent: -30,
    ease: 'none',
    scrollTrigger: {
      trigger: hero,
      start: 'top top',
      end: 'bottom top',
      scrub: 1.5,
    },
  });
})();


/* ---------- HERO — product image circle reveal on scroll ---------- */
(function () {
  var hero    = document.querySelector('.hero-brand');
  var product = hero ? hero.querySelector('.hero-brand__product') : null;
  if (!product) return;

  var maskCircle = product.querySelector('#circleMask-product circle');
  var svgImage   = product.querySelector('image');
  if (!maskCircle) return;

  var finalR = parseFloat(maskCircle.getAttribute('data-value-final'));

  if (window.innerWidth <= 1024) {
    maskCircle.setAttribute('r', finalR);
  } else {
    gsap.timeline({
      scrollTrigger: {
        trigger: hero,
        start: 'top top',
        end: '+=35%',
        scrub: 1,
      },
    })
    .fromTo(maskCircle, { attr: { r: 0 } }, { attr: { r: finalR }, ease: 'none' }, 0)
    .fromTo(svgImage,   { scale: 1.1, transformOrigin: '50% 50%' }, { scale: 1, ease: 'none' }, 0);
  }
})();


/* ---------- MARCHE — dafne image circle reveal ---------- */
(function () {
  var section    = document.querySelector('.brand-marche');
  var imgWrap    = section ? section.querySelector('.brand-marche__img') : null;
  if (!imgWrap) return;

  var maskCircle = imgWrap.querySelector('#circleMask-marche circle');
  var svgImage   = imgWrap.querySelector('image');
  if (!maskCircle) return;

  var finalR = parseFloat(maskCircle.getAttribute('data-value-final'));

  /* Circle reveal — parte quando la sezione è centrata nello schermo */
  if (window.innerWidth <= 1024) {
    maskCircle.setAttribute('r', finalR);
  } else {
    gsap.timeline({
      scrollTrigger: {
        trigger: section,
        start: 'top center',
        end: '+=55%',
        scrub: 1.2,
      },
    })
    .fromTo(maskCircle, { attr: { r: 0 } }, { attr: { r: finalR }, ease: 'none' }, 0)
    .fromTo(svgImage,   { scale: 1.12, transformOrigin: '50% 50%' }, { scale: 1, ease: 'none' }, 0);
  }

  /* Centramento verticale gestito da GSAP (CSS transform rimosso) */
  gsap.set(imgWrap, { yPercent: -50 });

  /* Parallax — scorre su tutta la durata della sezione */
  gsap.fromTo(imgWrap,
    { y: 35 },
    {
      y: -35,
      ease: 'none',
      scrollTrigger: {
        trigger: section,
        start: 'top bottom',
        end: 'bottom top',
        scrub: 2,
      },
    }
  );
})();


/* ---------- MARCHE — testo reveal ---------- */
(function () {
  var section = document.querySelector('.brand-marche');
  if (!section) return;

  var title = section.querySelector('.brand-marche__title');
  var cols  = section.querySelectorAll('.brand-marche__col');

  /* Su mobile/tablet: visibili subito senza animazione scroll */
  if (window.innerWidth <= 1024) {
    if (title) gsap.set(title, { opacity: 1, y: 0 });
    if (cols.length) gsap.set(cols, { opacity: 1, y: 0 });
    return;
  }

  /* Imposta stato iniziale via GSAP (non CSS transform, evita conflitti) */
  if (title) gsap.set(title, { y: 22 });
  if (cols.length) gsap.set(cols, { y: 16 });

  if (title) {
    gsap.to(title, {
      opacity: 1,
      y: 0,
      duration: 1,
      ease: 'power3.out',
      scrollTrigger: {
        trigger: section,
        start: 'top center',
      },
    });
  }

  if (cols.length) {
    gsap.to(cols, {
      opacity: 1,
      y: 0,
      duration: 0.9,
      stagger: 0.18,
      ease: 'power3.out',
      scrollTrigger: {
        trigger: section,
        start: 'top 40%',
      },
    });
  }
})();


/* ---------- MARCHE — parallax contenuto testo ---------- */
(function () {
  var section = document.querySelector('.brand-marche');
  if (!section) return;

  var content = section.querySelector('.brand-marche__content');
  if (!content) return;

  gsap.fromTo(content,
    { yPercent: -3 },
    {
      yPercent: 3,
      ease: 'none',
      scrollTrigger: {
        trigger: section,
        start: 'top bottom',
        end: 'bottom top',
        scrub: 2.5,
      },
    }
  );
})();


/* ---------- MARCHE → RICERCA — video zoom + pin ---------- */
(function () {
  if (window.innerWidth <= 1024) return;
  var marche  = document.querySelector('.brand-marche');
  var zoom    = document.querySelector('.brand-ricerca__zoom');
  var video   = zoom ? zoom.querySelector('.brand-ricerca__zoom-video') : null;
  var ricerca = document.querySelector('.brand-ricerca');
  if (!marche || !zoom || !video || !ricerca) return;

  /* Scale: da 76px a max 800px mantenendo proporzioni */
  var scaleFinal = Math.min(700, window.innerWidth - 40) / 76;

  /* Stato iniziale: invisibile e non scalato */
  gsap.set(zoom, { scale: 1, opacity: 0 });
  zoom.style.visibility = 'hidden';

  /* Timeline zoom — espansione */
  var zoomTl = gsap.timeline({ paused: true });

  zoomTl.to(zoom, { opacity: 1, duration: 0.1 }, 0.10);
  zoomTl.to(zoom, {
    scale: scaleFinal,
    ease: 'power2.inOut',
    duration: 0.90,
  }, 0.10);

  /* Pin su marche — pinType transform evita lo scatto con Lenis */
  ScrollTrigger.create({
    trigger: marche,
    start: 'bottom bottom',
    end: '+=220%',
    pin: true,
    pinType: 'transform',
    scrub: 2,
    anticipatePin: 1,
    invalidateOnRefresh: true,
    animation: zoomTl,
    onEnter: function () {
      zoom.style.visibility = 'visible';
    },
    onEnterBack: function () {
      zoom.style.visibility = 'visible';
    },
    onLeaveBack: function () {
      video.pause();
      video.currentTime = 0;
      zoom.style.visibility = 'hidden';
    },
  });

})();


/* ---------- RICERCA — video autoplay + zoom shrink ---------- */
(function () {
  if (window.innerWidth <= 1024) return;
  var ricerca = document.querySelector('.brand-ricerca');
  var zoom    = document.querySelector('.brand-ricerca__zoom');
  var video   = zoom ? zoom.querySelector('.brand-ricerca__zoom-video') : null;
  if (!ricerca || !zoom || !video) return;

  var scaleFinal = Math.min(700, window.innerWidth - 40) / 76;

  var nav    = document.querySelector('.dett-nav');
  var burger = document.querySelector('.dett-burger');
  var bottom = document.querySelector('.dett-hero__bottom');
  var cursor = document.getElementById('cursor');

  function navDark() {
    if (nav)    nav.classList.add('nav--dark');
    if (burger) burger.classList.add('nav--dark');
    if (bottom) bottom.classList.add('bottom--dark');
    if (cursor) cursor.classList.add('Cursor--dark');
  }
  function navLight() {
    if (nav)    nav.classList.remove('nav--dark');
    if (burger) burger.classList.remove('nav--dark');
    if (bottom) bottom.classList.remove('bottom--dark');
    if (cursor) cursor.classList.remove('Cursor--dark');
  }

  /* Shrink timeline: zoom rimpicciolisce */
  var shrinkTl = gsap.timeline({ paused: true });
  shrinkTl.to(zoom, {
    scale: 1,
    opacity: 0,
    ease: 'power2.inOut',
    duration: 1,
    immediateRender: false,
  }, 0);

  ScrollTrigger.create({
    trigger: ricerca,
    start: 'top top',
    end: '+=200%',
    pin: true,
    pinType: 'transform',
    scrub: 1.5,
    anticipatePin: 1,
    invalidateOnRefresh: true,
    animation: shrinkTl,
    onEnter: function () {
      navDark();
      video.currentTime = 0;
      video.play();
    },
    onEnterBack: function () { navDark(); },
    onLeave:     function () { navLight(); },
    onLeaveBack: function () { navLight(); },
  });
})();


/* ---------- NYMPHAI ITALY — scroll-driven velo slider ---------- */
(function () {
  var section  = document.querySelector('.nymphai-italy');
  if (!section) return;

  var pages    = Array.from(section.querySelectorAll('.nymphai-italy__page'));
  var navBtns  = Array.from(section.querySelectorAll('.nymphai-italy__nav-btn'));
  var veil     = section.querySelector('.nymphai-italy__veil');
  var veilLbl  = section.querySelector('.nymphai-italy__veil-label');
  var progFill = section.querySelector('.nymphai-italy__progress-fill');
  if (!pages.length) return;

  /* Su tablet/mobile: tutte le slide visibili in colonna, nessun pin */
  if (window.innerWidth <= 1024) {
    pages.forEach(function (p) { p.classList.add('is-active'); });

    /* Cover reveal + autoplay loop video/immagine su scroll via IntersectionObserver */
    var mediaEls = Array.from(section.querySelectorAll('.nymphai-italy__media-content'));

    var mediaObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          /* Rivela cover */
          var wrap = entry.target.closest('.nymphai-italy__media');
          var cover = wrap ? wrap.querySelector('.nymphai-italy__media-cover') : null;
          if (cover) cover.classList.add('is-revealed');
          /* Avvia video */
          if (entry.target.tagName === 'VIDEO') {
            entry.target.loop = true;
            entry.target.muted = true;
            entry.target.play();
          }
        } else {
          if (entry.target.tagName === 'VIDEO') entry.target.pause();
        }
      });
    }, { threshold: 0.3 });

    mediaEls.forEach(function (el) { mediaObserver.observe(el); });

    return;
  }

  var total        = pages.length;
  var current      = 0;
  var busy         = false;
  var introPlayed  = false;
  var introDone    = false;
  var locked       = false;
  var releaseTimer = null;
  var st;


  gsap.registerPlugin(CustomEase);
  CustomEase.create('italy-veil-in',  'M0,0 C0.42,0 0.18,1 1,1');
  CustomEase.create('italy-veil-out', 'M0,0 C0.82,0 0.58,1 1,1');
  CustomEase.create('italy-word-in',  'M0,0 C0.16,1 0.3,1 1,1');

  function getEls(page) {
    return {
      words:   page.querySelectorAll('.nymphai-italy__word-inner'),
      eyebrow: page.querySelector('.nymphai-italy__eyebrow-inner'),
      desc:    page.querySelector('.nymphai-italy__desc-inner'),
      cta:     page.querySelector('.nymphai-italy__cta-inner'),
      cover:   page.querySelector('.nymphai-italy__media-cover'),
      number:  page.querySelector('.nymphai-italy__number'),
      video:   page.querySelector('video.nymphai-italy__media-content'),
    };
  }

  if (progFill) gsap.set(progFill, { width: (1 / total * 100) + '%' });

  /* Stato iniziale nascosto — subito al caricamento, prima che la sezione entri in viewport */
  var e0 = getEls(pages[0]);
  gsap.set(e0.words, { yPercent: 105 });
  gsap.set([e0.eyebrow, e0.desc, e0.cta, e0.number].filter(Boolean), { opacity: 0, y: 16 });
  if (e0.cover) gsap.set(e0.cover, { scaleY: 1 });

  function playIntro() {
    if (introPlayed) return;
    introPlayed = true;
    busy = true;
    var e = getEls(pages[0]);

    var tl = gsap.timeline({
      delay: 0.1,
      onComplete: function () { introDone = true; busy = false; }
    });
    tl.to(e.words, { yPercent: 0, stagger: 0.09, duration: 1.1, ease: 'italy-word-in' }, 0);
    tl.to([e.eyebrow, e.desc, e.cta].filter(Boolean), { opacity: 1, y: 0, stagger: 0.1, duration: 0.7, ease: 'power3.out' }, 0.35);
    if (e.cover)  tl.to(e.cover,  { scaleY: 0, duration: 1.0, ease: 'power3.inOut' }, 0.3);
    if (e.number) tl.to(e.number, { opacity: 1, duration: 1.0, ease: 'power2.out'  }, 0.5);
    if (e.video)  tl.call(function () { e.video.play(); }, [], 0.3);
  }

  function goTo(idx) {
    if (idx === current || busy || idx < 0 || idx >= total) return;
    busy = true;

    var dir  = idx > current ? 1 : -1;
    var from = pages[current];
    var to   = pages[idx];
    var eF   = getEls(from);
    var eT   = getEls(to);

    navBtns.forEach(function (b, i) { b.classList.toggle('is-active', i === idx); });
    if (progFill) gsap.to(progFill, { width: ((idx + 1) / total * 100) + '%', duration: 1.4, ease: 'power2.inOut' });

    gsap.set(eT.words,  { yPercent: 70 * dir });
    gsap.set([eT.eyebrow, eT.desc, eT.cta, eT.number].filter(Boolean), { opacity: 0, y: 14 });
    if (eT.cover) gsap.set(eT.cover, { scaleY: 0 });

    var tl = gsap.timeline({ onComplete: function () { busy = false; current = idx; } });

    /* EXIT */
    tl.to(eF.words, { yPercent: -80 * dir, stagger: { each: 0.05, from: dir > 0 ? 'start' : 'end' }, duration: 0.45, ease: 'power2.in' }, 0);
    tl.to([eF.eyebrow, eF.desc, eF.cta, eF.number].filter(Boolean), { opacity: 0, y: -10, stagger: 0.04, duration: 0.3, ease: 'power2.in' }, 0);
    if (eF.cover) tl.to(eF.cover, { scaleY: 1, transformOrigin: 'top center', duration: 0.55, ease: 'power2.inOut' }, 0.05);
    if (eF.video) tl.call(function () { eF.video.pause(); }, [], 0);

    /* VEIL IN */
    if (veil) tl.fromTo(veil, { x: dir > 0 ? '-115%' : '115%', skewX: dir > 0 ? 7 : -7 }, { x: '0%', skewX: 0, duration: 0.72, ease: 'italy-veil-in' }, 0.15);
    if (veilLbl) tl.to(veilLbl, { opacity: 1, duration: 0.18 }, 0.58);

    /* SWAP */
    tl.call(function () { from.classList.remove('is-active'); to.classList.add('is-active'); }, [], 0.78);

    /* VEIL OUT */
    if (veilLbl) tl.to(veilLbl, { opacity: 0, duration: 0.14 }, 0.8);
    if (veil) tl.to(veil, { x: dir > 0 ? '115%' : '-115%', skewX: dir > 0 ? -7 : 7, duration: 0.68, ease: 'italy-veil-out' }, 0.84);

    /* ENTER */
    tl.to(eT.words, { yPercent: 0, stagger: { each: 0.08, from: dir > 0 ? 'start' : 'end' }, duration: 0.85, ease: 'italy-word-in' }, 0.88);
    tl.to([eT.eyebrow, eT.desc, eT.cta].filter(Boolean), { opacity: 1, y: 0, stagger: 0.1, duration: 0.65, ease: 'power3.out' }, 0.96);
    if (eT.cover)  tl.to(eT.cover,  { scaleY: 0, duration: 1.0, ease: 'power3.inOut' }, 0.88);
    if (eT.number) tl.to(eT.number, { opacity: 1, duration: 0.9, ease: 'power2.out'  }, 0.92);
    if (eT.video)  tl.call(function () { eT.video.currentTime = 0; eT.video.play(); }, [], 0.84);
  }

  /* Scroll lock / unlock — usa Lenis se disponibile, altrimenti wheel preventDefault */
  function lock() {
    if (locked) return;
    locked = true;
    if (window.lenis) window.lenis.stop();
    window.addEventListener('wheel', onWheel, { passive: false });
  }

  function unlock() {
    if (!locked) return;
    locked = false;
    window.removeEventListener('wheel', onWheel);
    if (releaseTimer) { clearTimeout(releaseTimer); releaseTimer = null; }
    if (window.lenis) window.lenis.start();
  }

  function scrollTo(y) {
    if (window.lenis) {
      window.lenis.scrollTo(y, { duration: 0.7 });
    } else {
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  }

  function onWheel(e) {
    e.preventDefault();

    var dir  = e.deltaY > 0 ? 1 : -1;
    var next = current + dir;

    /* Se l'utente inverte direzione, cancella il timer di rilascio */
    if (dir < 0 && releaseTimer) {
      clearTimeout(releaseTimer);
      releaseTimer = null;
    }

    if (busy) return;

    if (next >= 0 && next < total) {
      /* Slide normale */
      goTo(next);
    } else if (next >= total) {
      /* Ultima slide + scroll giù → attendi 2s poi rilascia */
      if (!releaseTimer) {
        releaseTimer = setTimeout(function () {
          unlock();
          scrollTo(st.end + 100);
        }, 1000);
      }
    } else {
      /* Prima slide + scroll su → rilascio immediato */
      unlock();
      scrollTo(st.start - 100);
    }
  }

  st = ScrollTrigger.create({
    trigger: section,
    start: 'top top',
    end: '+=' + (total * 100) + 'vh',
    pin: true,
    pinType: 'transform',
    anticipatePin: 1,
    invalidateOnRefresh: true,
    onEnter: function () {
      current = 0;
      introDone = true;
      playIntro();
      lock();
    },
    onLeave: function () {
      unlock();
    },
    onEnterBack: function () {
      /* Entrata dal basso: mostra ultima slide */
      current   = total - 1;
      introDone = true;
      pages.forEach(function (p, i) { p.classList.toggle('is-active', i === total - 1); });
      navBtns.forEach(function (b, i) { b.classList.toggle('is-active', i === total - 1); });
      if (progFill) gsap.set(progFill, { width: '100%' });
      lock();
    },
    onLeaveBack: function () {
      unlock();
      introPlayed = false;
      introDone   = false;
      current     = 0;
      pages.forEach(function (p, i) { p.classList.toggle('is-active', i === 0); });
      navBtns.forEach(function (b, i) { b.classList.toggle('is-active', i === 0); });
      if (progFill) gsap.set(progFill, { width: (1 / total * 100) + '%' });
    },
  });
})();


/* ---------- FILOSOFIA — image reveal + text ---------- */
(function () {
  var section = document.querySelector('.brand-filosofia');
  if (!section) return;

  /* Parallax leggero sul bg */
  var bg = section.querySelector('.brand-filosofia__bg');
  if (bg) {
    gsap.fromTo(bg, { yPercent: -8 }, {
      yPercent: 8,
      ease: 'none',
      scrollTrigger: {
        trigger: section,
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
      },
    });
  }

  /* SVG circle mask reveal con displacement */
  var maskCircle = section.querySelector('#circleMask-filosofia circle');
  var svgImage   = maskCircle ? section.querySelector('.brand-filosofia__image image') : null;
  if (maskCircle && svgImage) {
    var finalR = parseFloat(maskCircle.getAttribute('data-value-final'));
    if (window.innerWidth <= 1024) {
      maskCircle.setAttribute('r', finalR);
    } else {
      gsap.timeline({
        scrollTrigger: {
          trigger: '.brand-filosofia__image',
          start: 'top 85%',
          end: '+=40%',
          scrub: true,
        },
      })
      .fromTo(maskCircle, { attr: { r: 0 } }, { attr: { r: finalR }, ease: 'none' }, 0)
      .fromTo(svgImage, { scale: 1.08, transformOrigin: '50% 50%' }, { scale: 1, ease: 'none' }, 0);
    }
  }

  /* Titolo reveal */
  var title = section.querySelector('.brand-filosofia__title');
  if (title) {
    gsap.from(title, {
      y: 60,
      opacity: 0,
      duration: 1,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: '.brand-filosofia__bottom',
        start: 'top 85%',
      },
    });
  }

  /* Colonne testo reveal */
  var cols = section.querySelectorAll('.brand-filosofia__col');
  if (cols.length) {
    gsap.from(cols, {
      y: 50,
      opacity: 0,
      duration: 0.9,
      stagger: 0.2,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: cols[0],
        start: 'top 85%',
      },
    });
  }

  /* Linea verticale cresce */
  var columns = section.querySelector('.brand-filosofia__columns');
  if (columns) {
    gsap.to(columns, {
      '--line-h': '100%',
      duration: 1,
      ease: 'power2.out',
      scrollTrigger: { trigger: columns, start: 'top 85%' },
    });
  }
})();


/* ---------- FOOTER — cursor dark ---------- */
(function () {
  var footer = document.querySelector('.footer');
  var cursor = document.getElementById('cursor');
  if (!footer || !cursor) return;

  ScrollTrigger.create({
    trigger: footer,
    start: 'top bottom',
    end: 'bottom bottom',
    onEnter:     function () { cursor.classList.add('Cursor--dark'); },
    onLeaveBack: function () { cursor.classList.remove('Cursor--dark'); },
  });
})();

/* ---------- FOOTER — is-on-footer nav color ---------- */
(function () {
  var nav    = document.querySelector('.dett-nav');
  var bottom = document.querySelector('.dett-hero__bottom');
  var footer = document.querySelector('.footer');
  if (!nav || !footer) return;

  ScrollTrigger.create({
    trigger: footer,
    start: 'top bottom',
    end: 'bottom top',
    onEnter:     function () { nav.classList.add('is-on-footer');    if (bottom) bottom.classList.add('is-on-footer'); },
    onLeaveBack: function () { nav.classList.remove('is-on-footer'); if (bottom) bottom.classList.remove('is-on-footer'); },
    onLeave:     function () { nav.classList.remove('is-on-footer'); if (bottom) bottom.classList.remove('is-on-footer'); },
  });
})();
